import { render, staticRenderFns } from "./template_product_reasons.vue?vue&type=template&id=23d8c6f4"
import script from "./template_product_reasons.vue?vue&type=script&lang=js"
export * from "./template_product_reasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports